var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--c-dark-blue3)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.313 5.313h10.375a1.3 1.3 0 0 1 1.296 1.296v7.782a1.3 1.3 0 0 1-1.297 1.297H5.313a1.3 1.3 0 0 1-1.297-1.297V6.609a1.3 1.3 0 0 1 1.297-1.296"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--c-dark-blue3)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.984 6.61 10.5 11.147 4.016 6.61"
  })));
};
export default SvgEmail;